export function isBeforeDate(targetDateString) {
  const date = new Date(targetDateString);
  if (!(date instanceof Date)) {
    throw new Error("Invalid input: Parameter must be a Date object.");
  }

  // Get the current date in the user's local time
  const now = new Date();

  // Adjust the input date to a pure local day comparison
  const localInputDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  // Get today's date in local time (midnight start)
  const localToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Compare if the input date is before today
  return localInputDate.getTime() <= localToday.getTime();
}
